import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import ItemsListEditorFormElement from "core/gd-ui/items-list-editor/items-list-editor-form-element";

export default function CustomFieldItemsList(props) {
    return (
        <FormRow label="Options">
            <ItemsListEditorFormElement form={props.form}
                                        name="listItems"
                                        incSeedName="listItemsIncSeed"
                                        colorSelectionEnabled={true}/>
            <FormError form={props.form} name="listItems" />
        </FormRow>
    );
}

CustomFieldItemsList.propTypes = {
    form: PropTypes.object
}